// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"957a2888","172":"b8efd75f","383":"159fa135","450":"3b4232e8","453":"67a77d47","540":"461ee421","635":"82411c6a","761":"35b24353","847":"f98464ba"}[chunkId] + ".chunk.js";
};